import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgRotateIcon from './svgs/RotateIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var rotateIcon = (props => useIcon(SvgRotateIcon, SvgRotateIcon, props));

export { rotateIcon as default };
